import { CursorArrowRippleIcon } from '@heroicons/react/20/solid';
import { useChannel } from '@services/channels';
import { useShop } from '@services/ShopProvider';
import Sidebar from '@components/Sidebar';
import OnboardingAccessControl from '@components/OnboardingAccessControl';
import { Protect } from '@clerk/clerk-react';

const LocalAds = () => {
	const { shop, data: shops } = useShop();
	const { data: googleChannel } = useChannel('google');
	const shopSelected = !!shop?.id;

	if (!shopSelected) return null;

	const googleEnabled = googleChannel?.status === 'enabled';
	const liaAvailable = shopSelected ? shop.availableChannels?.['local-ads'] : shops.some((shop) => shop.availableChannels?.['local-ads']);

	return (
		<OnboardingAccessControl allowedState={'shop.google.pos-link-ok'}>
			{googleEnabled && liaAvailable && (
				<Protect permission="org:channels_lia:manage">
					<Sidebar.Item to="/subscription">
						<CursorArrowRippleIcon />
						Local Ads plan
					</Sidebar.Item>
				</Protect>
			)}
		</OnboardingAccessControl>
	);
};

export default LocalAds;
